import { render, staticRenderFns } from "./FormUrl.vue?vue&type=template&id=3267039b&"
import script from "./FormUrl.vue?vue&type=script&lang=js&"
export * from "./FormUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports